/**
 * Component for our Graph on the volume of Exchanges.
 * 
 * @component
 */

import React from "react";
import VolumeGraph from "../VolumeGraph";

const exportHeaders = [
  {
    label: 'Volume',
    value: 'volume',
    key: 'volume',
  },
  {
    label: 'Date',
    value: 'date',
    key: 'date',
  }
];
class ExchangeVolume extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <VolumeGraph
        url="/api/analytics/exchange-volume-by-date"
        title="Exchange Volume"
        tab="Exchanges"
        tooltip="Shows the number of Exchange items requested per day."
        config={{
          xField: "date",
          yField: "volume",
          xAxis: { tickCount: 5 },
          yAxis: { tickInterval: 1 },
          shapeField: 'smooth'
        }}
        exportHeaders={exportHeaders}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        updateDate={this.props.updateDate}
      />
    );
  }
}

export default ExchangeVolume;
